const style = {
    displayBorder: {
        padding: "20px"
    },
    headLineBorder: {
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        alignItems: "center"
    },
    gridBorder: {
        marginTop: "10px",
        padding: "0px 10px 0px 10px"
    }
}

export default style;